import { Injectable } from '@angular/core';
import { EventPromoCode } from './event-promo-code.model';
import { IEventV4PromoCodesService } from './ievent-v4-promo-codes.service';
import { EventsServiceApiService } from 'src/app/shared/api/events-service-api.service';
import { ApiCacheOptions } from 'src/app/shared';

@Injectable({
  providedIn: 'root',
})
export class EventV4PromoCodesService implements IEventV4PromoCodesService {
  private _eventServiceBaseUrl: string = '/event/v2/promocode/';

  public constructor(private _eventApiService: EventsServiceApiService) {}

  public getEventPromoCodes = (eventId: number): Promise<Array<EventPromoCode>> => {
    let url: string = this._eventServiceBaseUrl + 'event/' + eventId.toString() + '/promo-codes';
    let cacheOptions = { CacheSeconds: 0, DisableCaching: true } as ApiCacheOptions;
    return this._eventApiService.get(url, cacheOptions);
  };

  public getEventPromoCode = (promoCodeId: number): Promise<EventPromoCode> => {
    let url: string = `${this._eventServiceBaseUrl}${promoCodeId.toString()}`;
    return this._eventApiService.get(url);
  };

  public upsertEventPromoCode = (eventPromoCode: EventPromoCode): Promise<any> => {
    if (eventPromoCode.PromoCodeId > 0) {
      return this._eventApiService.put(this._eventServiceBaseUrl, eventPromoCode);
    } else {
      return this._eventApiService.post(this._eventServiceBaseUrl, eventPromoCode).then((data: any) => {
        eventPromoCode.PromoCodeId = data;
      });
    }
  };

  public deleteEventPromoCode = (promoCodeId: number): Promise<any> => {
    return this._eventApiService.delete(this._eventServiceBaseUrl + promoCodeId);
  };

  public exportPromoCodes = (eventId: number): Promise<string> => {
    let url: string = `${this._eventServiceBaseUrl}event/${eventId.toString()}/promo-codes/export`;
    return this._eventApiService.get(url);
  };

  public exportPromoCode = (eventId: number, promoCodeId: number): Promise<string> => {
    let url = `${this._eventServiceBaseUrl}event/${eventId.toString()}/promo-code/${promoCodeId.toString()}/export`;
    return this._eventApiService.get(url);
  };
}
